import { useTheme } from '@emotion/react';
import { IconStaticStatusAlert, IconStaticStatusInfo, IconStaticStatusSuccess, IconStaticStatusWarning, IconRewardFilled } from '@hubble/icons/web';
import 'react';
import { Flex } from '../Flex/index.js';
import { cssShorthandPropsFilter, Spacer } from '../primitives/Spacer/index.js';
import { Text } from '../Text/index.js';
import { SectionMessageWrapper } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const getIconMap = colorScheme => ({
  alert: jsx(IconStaticStatusAlert, {}),
  info: jsx(IconStaticStatusInfo, {}),
  success: jsx(IconStaticStatusSuccess, {}),
  warning: jsx(IconStaticStatusWarning, {}),
  reward: jsx(IconRewardFilled, {
    color: colorScheme.status.default.content.reward
  })
});
const ARIA_LIVE_VALUES = {
  assertive: 'assertive',
  polite: 'polite'
};
const ARIA_ROLE_VALUES = {
  alert: 'alert',
  status: 'status'
};
function SectionMessage({
  ['data-testid']: testId,
  children,
  heading,
  renderButton,
  renderSecondButton,
  hasAriaLive = true,
  statusType = 'alert',
  ...props
}) {
  const {
    colorScheme
  } = useTheme();
  function ariaLiveAttrs() {
    if (!hasAriaLive) return {};
    if (statusType === 'alert' || statusType === 'warning') return {
      role: ARIA_ROLE_VALUES.alert,
      'aria-live': ARIA_LIVE_VALUES.assertive,
      'aria-atomic': true
    };
    if (statusType === 'success') {
      return {
        role: ARIA_ROLE_VALUES.status,
        'aria-live': ARIA_LIVE_VALUES.polite,
        'aria-atomic': true
      };
    }
  }
  return jsxs(SectionMessageWrapper, {
    "data-testid": testId,
    statusType: statusType,
    ...ariaLiveAttrs(),
    ...cssShorthandPropsFilter(props),
    children: [getIconMap(colorScheme)[statusType], jsxs(Flex, {
      justifyContent: "center",
      flexDirection: "column",
      children: [Boolean(heading) && jsx(Text.Heading, {
        size: "xs",
        children: heading
      }), Boolean(children) && jsx(Text.Body, {
        as: "div",
        size: "sm",
        mt: heading ? 0.5 : null,
        children: children
      }), Boolean(renderButton) && jsxs(Flex, {
        mt: 1.5,
        children: [jsx(Spacer, {
          mr: 1,
          children: renderButton
        }), renderSecondButton]
      })]
    })]
  });
}

export { SectionMessage };
